const themeDiscountSettings = [
	{ settings: theme.settings.special_discount_1, text: theme.strings.special_discount_1 },
	{ settings: theme.settings.special_discount_2, text: theme.strings.special_discount_2 },
	{ settings: theme.settings.special_discount_3, text: theme.strings.special_discount_3 },
	{ settings: theme.settings.special_discount_4, text: theme.strings.special_discount_4 },
	{ settings: theme.settings.special_discount_5, text: theme.strings.special_discount_5 },
	{ settings: theme.settings.special_discount_6, text: theme.strings.special_discount_6 },
	{ settings: theme.settings.special_discount_7, text: theme.strings.special_discount_7 },
	{ settings: theme.settings.special_discount_8, text: theme.strings.special_discount_8 },
	{ settings: theme.settings.special_discount_9, text: theme.strings.special_discount_9 },
	{ settings: theme.settings.special_discount_10, text: theme.strings.special_discount_10 }
];

const PRODUCT_CAROUSEL = {
	slide: '.cross-sell-popup-slide, .upsale-section__slide',
	media: '.cross-sell-popup-image-wrapper, .upsale-section__media',
	titleLink: '.cross-sell-popup-slide-title a, .upsale-section__product-title a',
	sizeSelect: '.cross-sell-popup-slide-size-picker, .upsale-section__size-select',
	label: '.cross-sell-popup-label, .upsale-section__label',
	price: '.cross-sell-popup-slide-price, .upsale-section__price',
	comparePrice: '.cross-sell-popup-slide-compare-price, .upsale-section__compare-price',
	colorsPicker: '.cross-sell-related-colors-picker, .upsale-section__colors',
	color: '.cross-sell-related-color, .upsale-section__color',
	colorSelected: '.cross-sell-related-color-selected, .upsale-section__color--selected',
};

const MEDIA_LOADING_CLASS = 'related-color-loading-images';
const MEDIA_LOADING_CLASS_UPSALE = 'is-loading';
const CROSS_SELL_BUTTON_LOADING_CLASS = 'is-adding';
const CROSS_SELL_BUTTON_FEEDBACK_TIMEOUT_MS = 4000;

function initUpsaleClickyBoxes(root = document) {
	if (typeof jQuery === 'undefined' || !jQuery.fn.clickyBoxes) {
		return;
	}
	jQuery(root)
		.find('[data-make-box]')
		.addClass('has-clickyboxes')
		.find(PRODUCT_CAROUSEL.sizeSelect)
		.filter(':not(.clickybox-replaced)')
		.clickyBoxes();
}

function refreshUpsaleClickyBoxes(selectEl) {
	if (!selectEl || typeof jQuery === 'undefined' || !jQuery.fn.clickyBoxes) {
		return;
	}
	const $select = jQuery(selectEl);
	$select.clickyBoxes('destroy');
	$select.next('.clickyboxes').remove();
	$select.removeClass('clickybox-replaced replaced').show();
	$select.clickyBoxes();
}

/* global Swiper jQuery */
document.addEventListener('DOMContentLoaded', () => {
	// Show confirmation message before removing product to cart
	const removeProductButtons = document.querySelectorAll('.cart-item-remove');
	removeProductButtons.forEach((removeProductButton) => {
		removeProductButton.addEventListener('click', (e) => {
			e.preventDefault();
			const confirmRemove = confirm(e.target.getAttribute('confirm-message'));
			if (confirmRemove) {
				const addToWishlist = e.target.getAttribute('wish-list-add');
				if (addToWishlist && window.wishList) {
					window.wishList.updateFromCartItemRemoval(e.target.dataset);
				}
				window.location.href = e.target.href;
			}
		});
	});

	// Render cross sell popup swiper
	const crossSellSwiper = document.querySelector('.cross-sell-popup-swiper.swiper');
	if (crossSellSwiper) {
		new Swiper(crossSellSwiper, {
			slidesPerView: 1,
			pagination: {
				el: crossSellSwiper.closest('.cross-sell-popup-wrapper')?.querySelector('.swiper-pagination'),
			},
			navigation: {
				nextEl: crossSellSwiper.closest('.cross-sell-popup-wrapper')?.querySelector('.swiper-button-next'),
				prevEl: crossSellSwiper.closest('.cross-sell-popup-wrapper')?.querySelector('.swiper-button-prev'),
			},
			breakpoints: {
				767: {
					slidesPerView: 3,
				},
			},
		});
	}

	initUpsaleCarouselSwiper();
	initUpsaleClickyBoxes(document);
	initCollectionRelatedColorPicker();
});

function initUpsaleCarouselSwiper() {
	const root = document.querySelector('.upsale-section--cart[data-cart-upsale-carousel]');
	if (!root || typeof Swiper === 'undefined') {
		return;
	}
	const el = root.querySelector('.upsale-section__swiper');
	if (!el) {
		return;
	}

	function upsaleNavAlignToMedia() {
		const slide =
			el.querySelector('.swiper-slide.swiper-slide-visible:not(.swiper-slide-duplicate)') ||
			el.querySelector('.swiper-slide-active:not(.swiper-slide-duplicate)');
		if (!slide) {
			return;
		}
		const media = slide.querySelector('.upsale-section__media');
		if (!media) {
			return;
		}
		const swiperTop = el.getBoundingClientRect().top;
		const mediaRect = media.getBoundingClientRect();
		const center = mediaRect.top - swiperTop + mediaRect.height / 2;
		el.style.setProperty('--upsale-nav-top', `${Math.round(center)}px`);
	}

	new Swiper(el, {
		slidesPerView: 1.5,
		spaceBetween: 8,
		rtl: false,
		pagination: {
			el: root.querySelector('.upsale-section__pagination'),
		},
		navigation: {
			nextEl: root.querySelector('.upsale-section__nav-next'),
			prevEl: root.querySelector('.upsale-section__nav-prev'),
		},
		breakpoints: {
			768: {
				slidesPerView: 3,
				spaceBetween: 10,
			},
		},
		on: {
			init() {
				requestAnimationFrame(upsaleNavAlignToMedia);
			},
			slideChange: upsaleNavAlignToMedia,
			slideChangeTransitionEnd: upsaleNavAlignToMedia,
			resize: upsaleNavAlignToMedia,
			breakpoint: upsaleNavAlignToMedia,
		},
	});

	window.addEventListener('resize', upsaleNavAlignToMedia);
	if (typeof ResizeObserver !== 'undefined') {
		new ResizeObserver(upsaleNavAlignToMedia).observe(el);
	}
	root.querySelectorAll('img').forEach((img) => {
		if (img.complete) {
			return;
		}
		img.addEventListener('load', upsaleNavAlignToMedia, { once: true });
	});

	requestAnimationFrame(() => {
		requestAnimationFrame(upsaleNavAlignToMedia);
	});
}

/* exported toggleCrossSellPopup */
function toggleCrossSellPopup(isPopupActive) {
	/* global CROSS_SELL_COOKIE_KEY, CROSS_SELL_COOKIE_DAYS_TO_EXPIRE, setCookie, getCookie, addVariantToCart, CROSS_SELL_ADD_TO_CART_SUCCESS_MESSAGE, CROSS_SELL_ADD_TO_CART_FAIL_MESSAGE */
	/* exported addCrossSellProductToCart */

	const goToCheckoutBtn = document.getElementById('update-cart');
	const crossSellPopup = document.getElementById('cross-sell-popup');

	if (!isPopupActive) {
		setCookie(CROSS_SELL_COOKIE_KEY, true, CROSS_SELL_COOKIE_DAYS_TO_EXPIRE);
		crossSellPopup.classList.remove('active');
		goToCheckoutBtn.click();
		return;
	}

	if (getCookie(CROSS_SELL_COOKIE_KEY)) {
		crossSellPopup.classList.remove('active');
		goToCheckoutBtn.click();
		return;
	}
	crossSellPopup.classList.add('active');
}

function getCrossSellButtonLabelEl(btn) {
	return btn.querySelector('.cross-sell-add-button__label');
}

function ensureCrossSellButtonLabel(btn) {
	let label = getCrossSellButtonLabelEl(btn);
	if (!label) {
		label = document.createElement('span');
		label.className = 'cross-sell-add-button__label';
		label.textContent = btn.textContent.trim();
		btn.textContent = '';
		btn.prepend(label);
	}
	return label;
}

function getCrossSellButtonDefaultLabel(btn) {
	if (!btn.dataset.defaultLabel) {
		const label = getCrossSellButtonLabelEl(btn);
		btn.dataset.defaultLabel = (label ? label.textContent : btn.textContent).trim();
	}
	return btn.dataset.defaultLabel;
}

function setCrossSellButtonLoading(btn, isLoading) {
	btn.classList.toggle(CROSS_SELL_BUTTON_LOADING_CLASS, isLoading);
	btn.setAttribute('aria-busy', isLoading ? 'true' : 'false');
	if (isLoading) {
		btn.disabled = true;
		ensureCrossSellButtonLabel(btn);
		if (!btn.querySelector('.cross-sell-add-button__spinner')) {
			const spinner = document.createElement('span');
			spinner.className = 'loading-spinner cross-sell-add-button__spinner';
			spinner.setAttribute('aria-hidden', 'true');
			btn.appendChild(spinner);
		}
		return;
	}
	btn.querySelector('.cross-sell-add-button__spinner')?.remove();
}

function showCrossSellButtonFeedback(btn, messageHtml, isSuccess) {
	btn.classList.toggle('is-success', isSuccess);
	btn.classList.toggle('is-error', !isSuccess);
	btn.innerHTML = messageHtml;
}

function resetCrossSellButton(btn) {
	btn.disabled = false;
	btn.classList.remove(CROSS_SELL_BUTTON_LOADING_CLASS, 'is-success', 'is-error');
	btn.setAttribute('aria-busy', 'false');
	btn.textContent = getCrossSellButtonDefaultLabel(btn);
}

function addCrossSellProductToCart(btn) {
	if (btn.disabled) {
		return;
	}
	getCrossSellButtonDefaultLabel(btn);

	const selectInput = document.getElementById(`${btn.dataset.selectId}`);
	const { productTitle, productDescription, productBrand } = btn.dataset;
	// Can select one variant at a time
	// eslint-disable-next-line no-magic-numbers
	const selectedVariant = selectInput.selectedOptions[0];
	const selectedVariantId = selectedVariant.dataset.variantId;

	setCrossSellButtonLoading(btn, true);

	// eslint-disable-next-line no-magic-numbers
	addVariantToCart(selectedVariantId, 1, false).then((response) => {
		setCrossSellButtonLoading(btn, false);

		const isSuccess = Boolean(response?.success);
		const messageHtml = isSuccess
			? CROSS_SELL_ADD_TO_CART_SUCCESS_MESSAGE
			: CROSS_SELL_ADD_TO_CART_FAIL_MESSAGE;

		if (isSuccess) {
			// Tiktok pixel add to cart event
			const productData = {
				contents: [
					{
						'content_id': selectedVariant.dataset.variantSku,
						'content_name': productTitle,
						'brand': productBrand,
						'quantity': 1,
					}],
				'value': new Intl.NumberFormat('he-IL', { minimumFractionDigits: 2, currency: 'ILS' }).format(selectedVariant.dataset.variantPrice),
				'content_type': 'product',
				'description': productDescription,
				'currency': 'ILS',
			};
			// eslint-disable-next-line no-undef
			tiktokPixelAddToCart(productData);
		}

		showCrossSellButtonFeedback(btn, messageHtml, isSuccess);
		setTimeout(() => {
			resetCrossSellButton(btn);
		}, CROSS_SELL_BUTTON_FEEDBACK_TIMEOUT_MS);
	});
}

// Cross sell popup related colors
function initCollectionRelatedColorPicker() {
	const relatedColors = document.querySelectorAll(`${PRODUCT_CAROUSEL.color}:not(.related-color-loaded)`);
	if (relatedColors.length) {
		[...relatedColors].forEach((color) => {
			// Return if single colored product
			if (!color.nextElementSibling && !color.previousElementSibling) {
				return;
			}
			color.addEventListener('click', () => changeToRelatedProduct(color));
			color.addEventListener('keydown', (e) => {
				if (e.key === 'Enter' || e.key === ' ') {
					e.preventDefault();
					changeToRelatedProduct(color);
				}
			});

			color.classList.add('related-color-loaded');
		});
	}
}

function setMediaLoadingState(mediaEl, isLoading) {
	if (!mediaEl) {
		return;
	}
	mediaEl.classList.toggle(MEDIA_LOADING_CLASS, isLoading);
	mediaEl.classList.toggle(MEDIA_LOADING_CLASS_UPSALE, isLoading);
}

// Related color product change
// eslint-disable-next-line no-unused-vars
async function changeToRelatedProduct(color) {
	// If same color click again, do nothing
	const colorPickerWrapper = closestFrom(color, PRODUCT_CAROUSEL.colorsPicker);
	const productPreviousColor = colorPickerWrapper?.querySelector(
		PRODUCT_CAROUSEL.colorSelected
	);
	if (color.isEqualNode(productPreviousColor)) {
		return;
	}
	const productBlock = closestFrom(color, PRODUCT_CAROUSEL.slide);
	if (!productBlock) {
		return;
	}

	// Loading state
	const slideImageWrapper = queryWithin(productBlock, PRODUCT_CAROUSEL.media);
	const slideImage = slideImageWrapper?.querySelector('img');
	setMediaLoadingState(slideImageWrapper, true);

	// Collect data
	const relatedColorRawData = await fetch(`/products/${color.dataset.productHandle}.json`);
	const relatedColorData = await relatedColorRawData.json();
	const productLink = queryWithin(productBlock, PRODUCT_CAROUSEL.titleLink);
	const relatedColorImageUrl = relatedColorData.product.image.src;
	const newProductUrl = `${window.location.origin}/products/${relatedColorData.product.handle}`;
	const productVariantsSelect = queryWithin(productBlock, PRODUCT_CAROUSEL.sizeSelect);

	// Change product settings
	productLink.href = newProductUrl;
	slideImage.src = relatedColorImageUrl;

	updateVariantsSelectOptions(productVariantsSelect, relatedColorData, color);
	setProductPrices(productBlock, relatedColorData);
	handleProductLabelTags(relatedColorData, productBlock, slideImageWrapper);

	// Change selected color
	productPreviousColor?.classList.remove('cross-sell-related-color-selected', 'upsale-section__color--selected');
	color.classList.add('cross-sell-related-color-selected', 'upsale-section__color--selected');

	// Remove loading state
	setMediaLoadingState(slideImageWrapper, false);
}

function handleProductLabelTags(relatedColorData, productBlock, slideImageWrapper) {
	const productTags = relatedColorData.product.tags.split(',').map((tag) => tag.trim());
	const productTagLabel = '_labelText';
	const productLabelDiv = queryWithin(productBlock, PRODUCT_CAROUSEL.label);

	let hasMatchingLabel = false;

	for (let i = 0; i < productTags.length; i++) {
		const tag = productTags[i];

		if (tag.includes(productTagLabel)) {
			const labelText = tag.split('_').pop();
			hasMatchingLabel = true;

			handleproductLabelDiv(productLabelDiv, slideImageWrapper, labelText);
		}
	}

	handleRemoveLabelDiv(hasMatchingLabel, productLabelDiv);
}

function handleproductLabelDiv(productLabelDiv, slideImageWrapper, labelText) {
	if (!productLabelDiv) {
		const newLabelDiv = document.createElement('div');
		newLabelDiv.classList.add('cross-sell-popup-label', 'upsale-section__label');
		newLabelDiv.innerText = labelText;
		slideImageWrapper.appendChild(newLabelDiv);
	} else {
		productLabelDiv.innerText = labelText;
	}
}

function handleRemoveLabelDiv(hasMatchingLabel, productLabelDiv) {
	if (!hasMatchingLabel && productLabelDiv) {
		productLabelDiv.remove();
	}
}

function getSizeOptionPosition(product) {
	const sizeOption = (product.options || []).find((opt) => {
		const nameLower = (opt.name || '').toLowerCase();
		return nameLower === 'size' || nameLower === 'מידה' || opt.name === 'SIZE';
	});
	return sizeOption?.position ?? null;
}

function getVariantOptionByPosition(variant, position) {
	return variant[`option${position}`];
}

function getSelectedSizeValue(selectEl) {
	if (!selectEl?.selectedOptions?.[0]) {
		return null;
	}
	const selected = selectEl.selectedOptions[0];
	if (selected.value && !/^\d+$/.test(String(selected.value))) {
		return selected.value;
	}
	const text = selected.textContent.trim();
	if (text.includes('/')) {
		return text.split('/').pop().trim();
	}
	return text || null;
}

function parseSizesAvailability(colorEl) {
	const raw = colorEl?.dataset?.productSizesAvalibility;
	if (!raw) {
		return null;
	}
	return Object.fromEntries(
		raw.split(',').map((entry) => {
			const [size, available] = entry.split(':');
			return [size, available === 'true'];
		})
	);
}

function isVariantAvailableForUpsale(variant) {
	if (variant.available === false) {
		return false;
	}
	if (variant.available === true) {
		return true;
	}
	if (typeof variant.inventory_quantity === 'number' && variant.inventory_management === 'shopify') {
		if (variant.inventory_quantity <= 0 && variant.inventory_policy !== 'continue') {
			return false;
		}
	}
	return true;
}

function buildSizeSelectOptions(product, sizesAvailability = null) {
	const sizePosition = getSizeOptionPosition(product);
	if (!sizePosition) {
		return null;
	}

	const sizeOption = product.options.find((opt) => opt.position === sizePosition);
	const sizeValues = sizeOption?.values || [];
	const options = [];

	for (const sizeValue of sizeValues) {
		if (sizesAvailability && sizesAvailability[sizeValue] !== true) {
			continue;
		}

		const matchingVariants = product.variants.filter(
			(v) => getVariantOptionByPosition(v, sizePosition) === sizeValue
		);
		const variant = sizesAvailability
			? matchingVariants[0]
			: matchingVariants.find((v) => isVariantAvailableForUpsale(v));

		if (!variant) {
			continue;
		}

		const option = document.createElement('option');
		option.value = sizeValue;
		option.textContent = sizeValue;
		option.dataset.variantId = String(variant.id);
		option.dataset.variantPrice = String(variant.price);
		option.dataset.variantSku = variant.sku || '';
		option.dataset.brand = product.vendor || '';
		options.push(option);
	}

	return options;
}

function updateVariantsSelectOptions(productVariantsSelect, relatedColorData, colorEl) {
	// Update variants select options
	const product = relatedColorData.product;
	const previousSize = getSelectedSizeValue(productVariantsSelect);
	const sizesAvailability = parseSizesAvailability(colorEl);

	const builtOptions = buildSizeSelectOptions(product, sizesAvailability);
	const newVariantsSelectOptions = builtOptions?.length
		? builtOptions
		: product.variants.map((variant) => {
		const option = document.createElement('option');
		option.value = variant.id;
		option.dataset.variantId = String(variant.id);
		option.textContent = variant.title;
		return option;
	});

	productVariantsSelect.innerHTML = '';
	newVariantsSelectOptions.forEach((option) => {
		productVariantsSelect.appendChild(option);
	});

	if (previousSize && [...productVariantsSelect.options].some((o) => o.value === previousSize)) {
		productVariantsSelect.value = previousSize;
	}

	refreshUpsaleClickyBoxes(productVariantsSelect);
}

function setProductPrices(productBlock, relatedColorData) {
	// Set prices to cheapest product variant (Theme behavior at collection page)
	// eslint-disable-next-line no-magic-numbers
	const firstVariant = relatedColorData.product.variants.sort((a, b) => a.price - b.price)[0];

	const productPrice = queryWithin(productBlock, PRODUCT_CAROUSEL.price);
	if (productPrice) {
		productPrice.innerText = `${firstVariant.price} ₪`;
	}

	const productComparePrice = queryWithin(productBlock, PRODUCT_CAROUSEL.comparePrice);

	if (productComparePrice) {
		productComparePrice.innerText = `${firstVariant.compare_at_price} ₪`;
	}

	const productFinalePrice = productBlock.querySelector('.extra-discount-price span');
	if (productFinalePrice) {
		setProductExtraPrice(productFinalePrice, relatedColorData, firstVariant);
	}
}

// eslint-disable-next-line complexity
function setProductExtraPrice(productFinalePrice, relatedColorData, firstVariant) {
	let extraDiscount = theme.settings.extra_discount.amount;
	let extraDiscountText = theme.strings.extra_discount;
	const productTags = relatedColorData.product.tags.split(',').map((tag) => tag.trim());
	const excludedTags = theme.settings.extra_discount.excluded_tags.split(',').map((tag) => tag.trim()).filter(Boolean);
	let isDiscountedProduct = theme.settings.extra_discount.show && !productTags.some((tag) => excludedTags.includes(tag));

	// If product has special price, change extra discount to special extra discount

	for (let i = 0; i < productTags.length; i++) {
		const tag = productTags[i];

		for (const discountSetting of themeDiscountSettings) {
			const tags = discountSetting.settings.tags.split(',').map((tag) => tag.trim());
			if (discountSetting.settings.show && tags.includes(tag)) {
				extraDiscount = discountSetting.settings.amount;
				extraDiscountText = discountSetting.text;
				isDiscountedProduct = true;
				break;
			}
		}
	}

	const productFinalePriceWrapper = productFinalePrice.parentElement;
	if (!isDiscountedProduct) {
		productFinalePrice.innerText = '';
		productFinalePriceWrapper.hidden = true;
		return;
	}

	// eslint-disable-next-line no-magic-numbers
	const extraDiscountAmount = firstVariant.price * (1 - extraDiscount / 100);
	const formatedExtraDiscount = new Intl.NumberFormat('he-IL', {
		style: 'currency',
		currency: 'ILS',
	}).format(extraDiscountAmount);
	productFinalePrice.innerText = `${extraDiscountText} ${formatedExtraDiscount}`;
	productFinalePriceWrapper.setAttribute('aria-label', productFinalePrice.innerText);
	productFinalePriceWrapper.hidden = false;
}
